import styled from 'styled-components';

const getBadgeStyles = (props) => {
  const { variant, theme } = props;
  
  if (variant === 'default') {
    return `
      background-color: ${theme.colors.primary};
      color: ${theme.colors.primaryForeground};
    `;
  }
  if (variant === 'secondary') {
    return `
      background-color: ${theme.colors.secondary};
      color: ${theme.colors.secondaryForeground};
    `;
  }
  if (variant === 'destructive') {
    return `
      background-color: ${theme.colors.destructive};
      color: ${theme.colors.destructiveForeground};
    `;
  }
  if (variant === 'outline') {
    return `
      border: 1px solid ${theme.colors.border};
      color: ${theme.colors.foreground};
      background-color: transparent;
    `;
  }
  
  // Category color variants
  const categoryColors = {
    coral: theme.colors.category.coral,
    teal: theme.colors.category.teal,
    amber: theme.colors.category.amber,
    violet: theme.colors.category.violet,
    emerald: theme.colors.category.emerald,
    rose: theme.colors.category.rose,
    sky: theme.colors.category.sky,
    lime: theme.colors.category.lime,
  };
  
  if (categoryColors[variant]) {
    const color = categoryColors[variant];
    return `
      background-color: ${color}26;
      color: ${color};
      border: 1px solid ${color}4d;
    `;
  }
  
  return '';
};

export const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  padding: 0.25rem 0.75rem;
  font-size: 0.8125rem;
  font-weight: 500;
  transition: colors 0.2s;
  
  @media (min-width: 1024px) {
    padding: 0.375rem 0.875rem;
    font-size: 0.875rem;
  }
  
  @media (min-width: 1440px) {
    padding: 0.5rem 1rem;
    font-size: 0.9375rem;
  }
  
  &:focus {
    outline: 2px solid ${props => props.theme.colors.ring};
    outline-offset: 2px;
  }
  
  ${props => getBadgeStyles(props)}
`;

Badge.defaultProps = {
  variant: 'default',
};


